import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import 'react-focus-on';
import '@reach/auto-id';
import '@reach/portal';
import '../Transition/index.js';
import '../Box/index.js';
import '../CloseButton/index.js';
import '../Modal/ModalContent.js';
import { ModalHeader } from '../Modal/ModalHeader.js';
import { Stack } from '../Stack/index.js';
import { Heading } from '../Heading/index.js';
import { Text } from '../Text/index.js';
import { Link } from '../Link/index.js';

/**
 * The DrawerHeader is a subcomponent of Drawer to provide Header content for the Drawer
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/drawer)
 * - [Props](https://blockparty.endpoint.com/components/drawer#drawerheader-props)
 * <br />
 *
 */
const DrawerHeader = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    title,
    description,
    contentSpacing = 'space50',
    alertSection,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(ModalHeader, _extends({
    ref: forwardedRef,
    closeButton: false
  }, rest), /*#__PURE__*/React__default.createElement(Stack, {
    mb: children ? 'space50' : 'space0',
    spacing: "space40"
  }, /*#__PURE__*/React__default.createElement(Heading, {
    as: "h1",
    size: "fontSize50"
  }, title), description && /*#__PURE__*/React__default.createElement(Text, {
    as: "p",
    size: "fontSize20"
  }, description), alertSection && alertSection), /*#__PURE__*/React__default.createElement(Link, {
    "aria-label": "Skip to Actions",
    href: "#drawer-footer"
  }), children && /*#__PURE__*/React__default.createElement(Stack, {
    spacing: contentSpacing
  }, children));
});

export { DrawerHeader };
